import colorAlphaPaletteLight from "../../../../src/pages/foundations/color/_assets/color-alpha-palette-light.png";
import colorApplyingColor2Light from "../../../../src/pages/foundations/color/_assets/color-applying-color-2-light.png";
import colorEmphasisLevelInverseLight from "../../../../src/pages/foundations/color/_assets/color-emphasis-level-inverse-light.png";
import colorEmphasisLevelStatusLight from "../../../../src/pages/foundations/color/_assets/color-emphasis-levels-status-light.png";
import colorEmphasisLevelsTextLight from "../../../../src/pages/foundations/color/_assets/color-emphasis-levels-text-light.png";
import colorInteractionStatesIconsLight from "../../../../src/pages/foundations/color/_assets/color-interaction-states-icons-light.png";
import colorInteractionStatesLight from "../../../../src/pages/foundations/color/_assets/color-interaction-states-light.png";
import colorNeutralPaletteLight from "../../../../src/pages/foundations/color/_assets/color-neutral-palette-light.png";
import colorRoleDoLight from "../../../../src/pages/foundations/color/_assets/color-role-do-light.png";
import colorRoleDontLight from "../../../../src/pages/foundations/color/_assets/color-role-dont-light.png";
import colorRolesLight from "../../../../src/pages/foundations/color/_assets/color-roles-light.png";
import colorSaturatedPaletteLight from "../../../../src/pages/foundations/color/_assets/color-saturated-palette-light.png";
import colorTokensInScreenLight from "../../../../src/pages/foundations/color/_assets/color-tokens-in-screen-light.png";
import { ColorRolesTable } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  colorAlphaPaletteLight,
  colorApplyingColor2Light,
  colorEmphasisLevelInverseLight,
  colorEmphasisLevelStatusLight,
  colorEmphasisLevelsTextLight,
  colorInteractionStatesIconsLight,
  colorInteractionStatesLight,
  colorNeutralPaletteLight,
  colorRoleDoLight,
  colorRoleDontLight,
  colorRolesLight,
  colorSaturatedPaletteLight,
  colorTokensInScreenLight,
  ColorRolesTable,
  React
};